import { YoutubePost } from './types';

import { getElapsedTime } from '../../../helpers/functions';

export const YoutubeCard = ({
  post: {
    channelTitle,
    description,
    permalink,
    publishedAt,
    thumbnails: {
      high: { url },
    },
  },
}: {
  post: YoutubePost;
}) => {
  return (
    <div
      className={`
        flex
        flex-col
        border-grey-10
        shadow-md
        border-1
        rounded-lg
        cursor-pointer
        overflow-hidden
        dark:border-grey-80
        h-80
      `}
      onClick={() => permalink && window.open(permalink, '_blank')}
    >
      <div className="h-1/4 p-4 flex flex-col justify-center">
        <p
          className={`
            font-semibold
            text-md
            overflow-ellipsis
            overflow-hidden
            whitespace-nowrap
          `}
        >
          {description}
        </p>
        <div className="flex justify-between gap-4 text-grey-50">
          <span
            className={`
              flex-grow-1
              overflow-ellipsis
              overflow-hidden
              whitespace-nowrap
            `}
            style={{ flexBasis: '0px' }}
          >
            {channelTitle}
          </span>
          <span>{getElapsedTime(new Date(publishedAt))}</span>
        </div>
      </div>
      <div
        className="h-3/4 bg-center cursor-pointer"
        style={{ backgroundImage: `url("${url}")` }}
      />
    </div>
  );
};
